/**
 * MODULE: domain/pages/frontend/utils/pageClipboardUtils.ts
 * PURPOSE: Copy workspace page URLs to the clipboard for sharing inside Brazn
 */

export function buildPagePath(workspaceId: string, pageId: string): string {
  return `/workspaces/${workspaceId}/pages/${pageId}`;
}

export function buildPageCommentPath(
  workspaceId: string,
  pageId: string,
  commentId: string,
  blockId?: string | null
): string {
  const params = new URLSearchParams();
  if (blockId) {
    params.set('block', blockId);
  }
  params.set('comment', commentId);
  return `${buildPagePath(workspaceId, pageId)}?${params.toString()}`;
}

export function buildPageAbsoluteUrl(workspaceId: string, pageId: string): string {
  const path = buildPagePath(workspaceId, pageId);
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return path;
}

export function buildPageCommentAbsoluteUrl(
  workspaceId: string,
  pageId: string,
  commentId: string,
  blockId?: string | null
): string {
  const path = buildPageCommentPath(workspaceId, pageId, commentId, blockId);
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return path;
}

export async function copyPageLink(workspaceId: string, pageId: string): Promise<void> {
  const url = buildPageAbsoluteUrl(workspaceId, pageId);
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return;
  }
  throw new Error('Clipboard is not available');
}

export async function copyPageCommentLink(
  workspaceId: string,
  pageId: string,
  commentId: string,
  blockId?: string | null
): Promise<void> {
  const url = buildPageCommentAbsoluteUrl(workspaceId, pageId, commentId, blockId);
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return;
  }
  throw new Error('Clipboard is not available');
}
